export var single_op_row = `
{{> operations/_op_row}}
`